import { approvalMethodNoticePeriodModel, relationshipModel } from "../../../../models";
import AmendmentChangesInAgreementView from "./AmendmentChangesInAgreementView";
import { getAmendmentsApprovalMethodChangeBullet } from "../../../../business-logic/amendmentsLogic";
import { SpecificTerm } from "./CommonComponents";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AgreementAmendmentsApprovalMethod(props) {
  const {
    relationship,
    testid
  } = props;
  const updated = relationshipModel.updatedAmendmentsApprovalMethod(relationship);
  const actual = relationshipModel.actualAmendmentsApprovalMethod(relationship);
  const isAutoApproval = approvalMethodNoticePeriodModel.isAutoApproval(actual);
  const changeBullet = updated ? getAmendmentsApprovalMethodChangeBullet(relationship.amendmentsApprovalMethod, updated.value()) : null;
  return isAutoApproval || updated ? /*#__PURE__*/_jsx(SpecificTerm, {
    field: "Amendments",
    value: approvalMethodNoticePeriodModel.amendmentsDescription(actual),
    testid: testid + 'notice-period',
    changes: changeBullet && /*#__PURE__*/_jsx(AmendmentChangesInAgreementView, {
      disableBorderRadius: true,
      items: [changeBullet],
      autoApprovalDate: relationshipModel.updatedAmendmentsApprovalMethodAutoApprovalDate(relationship),
      testid: testid + 'notice-changes'
    })
  }) : null;
}